const initialState ={
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case "DYNAMIC_TABLE_ERROR":
        return Object.assign({}, state, {
          showerror: action.showerror,
          errmessage: action.errmessage
      })
      case "DYNAMIC_TABLE_CLOSE":
        return Object.assign({}, state, {
          showerror: action.showerror
      }) 
   
     default:
      return state
    }
   }
  
   